import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { MoreVert } from '@mui/icons-material';
import { Sparkles } from 'lucide-react';
import { isAgendaJobRunning } from '../../../redux/meetingAgendaSlice';
const MenuSvgIcon = ({ src, alt }) => (_jsx(Box, { component: "img", src: src, alt: alt, sx: { width: 18, height: 18, display: 'block' }, onError: (e) => { e.currentTarget.style.display = 'none'; } }));
const ActionMenu = ({ row, canDelete, preparing = false, onView, onPrepare, onDelete, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);
    const wrap = (fn) => () => {
        handleClose();
        fn(row);
    };
    return (_jsxs(Box, { sx: { display: 'flex', justifyContent: 'center' }, children: [_jsx(IconButton, { size: "small", onClick: handleOpen, "aria-label": "row actions", sx: { color: '#667085' }, children: _jsx(MoreVert, { sx: { width: 20, height: 20 } }) }), _jsxs(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, slotProps: {
                    backdrop: { sx: { backgroundColor: 'rgba(0, 0, 0, 0.1)' } },
                    paper: {
                        sx: {
                            minWidth: 180,
                            boxShadow: '0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)',
                            border: '1px solid #EAECF0',
                            borderRadius: '8px',
                            mt: 0.5,
                            '& .MuiListItemText-primary': { fontSize: '14px !important' },
                        },
                    },
                }, children: [_jsxs(MenuItem, { onClick: wrap(onView), children: [_jsx(ListItemIcon, { sx: { minWidth: 34 }, children: _jsx(MenuSvgIcon, { src: "/assets/eye.svg", alt: "View" }) }), _jsx(ListItemText, { primary: "View" })] }), _jsxs(MenuItem, { onClick: wrap(onPrepare), disabled: preparing || isAgendaJobRunning(row.job), children: [_jsx(ListItemIcon, { sx: { minWidth: 34 }, children: preparing || isAgendaJobRunning(row.job) ? (_jsx(CircularProgress, { size: 16, sx: { color: '#EE2A7B' } })) : (_jsx(Sparkles, { size: 18, color: "#52525b" })) }), _jsx(ListItemText, { primary: preparing || row.job?.status === 'queued'
                                    ? 'Queued…'
                                    : row.job?.status === 'processing'
                                        ? 'Preparing…'
                                        : row.has_report
                                            ? 'Re-prepare Agenda'
                                            : 'Prepare Agenda' })] }), canDelete && (_jsxs(MenuItem, { onClick: wrap(onDelete), children: [_jsx(ListItemIcon, { sx: { minWidth: 34 }, children: _jsx(MenuSvgIcon, { src: "/assets/trash.svg", alt: "Delete" }) }), _jsx(ListItemText, { primary: "Delete" })] }))] })] }));
};
export default ActionMenu;
